// Module
import { useCallback, useEffect, useState } from 'react';

// CSS
import '_Asset/css/User/Page/design.css'

// Component
import { DropDownList, Pagination } from 'User/Component';
import axios from 'axios';
import { PolicyApi, RegApi } from '_Route/Api';
import { useNavigate, useParams } from 'react-router-dom';


const DevGuide = () => {

  const navigate = useNavigate();
  const params = useParams();

  // Tab Menu Array
  const menuArr = [
    { name: 'Security Policy', api: PolicyApi },
    { name: 'Development Regulation', api: RegApi }
  ]

  // Tab Menu Handler
  const [currentTab, setCurrentTab] = useState(0);
  const [curIndex, setCurIndex] = useState('');

  const selectMenuHandler = (index) => {
    setCurrentTab(index);
  }


  // 검색 및 페이징 API 호출
  const [guideInfo, setGuideInfo] = useState([]); // Search Result Paging Data
  const [guideRes, setGuideRes] = useState([]); // Search Result Data

  const [curPage, setCurPage] = useState(1); // 현재 페이지
  const [pageSize, setPageSize] = useState(30); // 한 페이지에 보여줄 건 수
  const [blockSize, setBlockSize] = useState(10); // 한 페이지에 보여줄 Pagination 블록 건 수

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // setLoading(false)
    axios.get(menuArr[currentTab].api, {
      params: {
        title: params.key === undefined ? '' : params.key,
        curPage: curPage,
        pageSize: pageSize,
        blockSize: blockSize
      }
    })
    .then(res => {
      setGuideInfo(res.data.pageInfo);
      setGuideRes(res.data.result);
      setLoading(true);
    })
    .catch(err => {
      console.error(err, "ERROR...")
      setLoading(true);
    })
  }, [params, curPage, currentTab])


  // Search Input Value Setting
  const [searchVal, setSearchVal] = useState(params.key || '');

  const onChangeSearch = useCallback(e => {
    setSearchVal(e.target.value);
  }, []);
  
  const onKeyPress = (e) => { if(e.key == 'Enter') onSearch(); }
  const onSearch = () => {
    navigate(`/design/development-guide${searchVal === '' ? '' : '/' + encodeURIComponent(searchVal)}`);
  }

  // Skeleton Component
  const Skeleton = ({num}) => {
    const result = [];

    for (let i = 0; i < num; i++) {
      result.push(
        <li key={i}>
          <button type="button" className="skeleton">
            <i className='icofont-rounded-right'></i>
            <span className="listTit">지원요청에 대한 해결방안은 언제 받을 수 있나요? 검토 중이라고 나옵니다.</span>
            <span className="listDate">2022.07.20</span>
          </button>
        </li>
      )
    }
    return result;
  }

  return (
    <>
      {/* Visual */}
      <div className="visual design">
        <div className="section">
          <div className="visualTitGroup">
            <h2 className="visualTit">Development Guide</h2>
            
            <p className="visualTxt">Check Security policies and development regulations.</p>
          </div>
        </div>
      </div>

      <div className="mainContents">
        <div className="section">
          <div className="devGuideArea areaBox">
            <div className="flexBox between">
              <div className="tabGroup type_2 sfrtBlue round_10">
                <div className="tabBar">
                  {
                    menuArr.map((key, i) => 
                      <button type="button" key={i} className={`btn sm ${currentTab === i ? 'active' : ''}`} onClick={() => selectMenuHandler(i)}>{key.name}</button>
                    )
                  }
                </div>
              </div>

              <fieldset>
                <legend>콘텐츠 검색</legend>

                <div className="fieldGroup mainSearch">
                  <div className="field">
                    <input type="input" className="input md" placeholder="검색어를 입력하세요." value={searchVal} onChange={onChangeSearch} onKeyPress={onKeyPress}/>
                    <button type="button" className="btn sm sfrtBlue i_only" onClick={onSearch}><i className="icofont-search"></i></button>
                  </div>
                </div>
              </fieldset>
            </div>

            <ul className="dropDownList">
              {
                loading ? 
                  guideRes.length !== 0 ?
                  <>
                    {guideRes.map((item, i) => 
                      <DropDownList key={i} item={item} index={i} curIndex={curIndex} setCurIndex={setCurIndex} currentTab={currentTab} page="devguide" />
                    )}
                    <div className="flexBox between">
                      <p className="pagingTxt">Page {curPage} of {guideInfo.pageCount}. Showing {guideInfo.count} results</p>

                      <Pagination
                        type="type_1"
                        size="sm"
                        curPage={curPage}
                        setCurPage={setCurPage}
                        pageSize={pageSize}
                        blockSize={blockSize}
                        startBlock={guideInfo.startBlock}
                        endBlock={guideInfo.endBlock}
                        pageCount={guideInfo.pageCount}
                      />
                    </div>
                  </>
                  :
                  <div className="noDataBox">
                    <i className="icofont-warning-alt"></i>
                    <p>No results found for <span>{params.key}</span>.<br /> Please enter another search term.</p>
                  </div>
                :
                <Skeleton num={15} />
              }
            </ul>
          </div>
        </div>
      </div>
    </>
  )
}

export default DevGuide;